/**
 * Created by saeed on 12/12/2016.
 */

angular.module('tikonApp').directive('eoMinValidator', ['$timeout', function ($timeout) {

    return {
        require: 'ngModel',
        link: function (scope, elm, attrs, ctrl) {
            $timeout(function () {
                var vm = this;
                //validator function
                ctrl.$validators.minValidator = function (modelValue, viewValue) {

                    if (modelValue) {
                        if ((+modelValue) < (+attrs.eoMinValidator)) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                };

            });

        }
    };
}]);
